import { ROUTE_PATHS } from "@/constants/navigation";
import { COGNITO_GROUP_NAMES } from "@/constants/cognitoGroups";
import type { FeaturesProperties } from "@/types/features";
import type { PermissionGrants } from "@/lib/permissions/permissionGrantsModel";

export type FeatureFlags = {
  readonly flags: readonly (keyof FeaturesProperties)[];
  readonly requiresAll: boolean;
};

export type PermissionRuleContext = {
  readonly organisation: string;
  readonly groups: readonly string[];
  readonly isExagens: boolean;
};

export type PermissionLanding = {
  readonly priority: number;
  readonly toPath: string;
};

export type PermissionRule = {
  readonly id: string;
  readonly when: (ctx: PermissionRuleContext) => boolean;
  readonly patch: Partial<PermissionGrants>;
  readonly featureFlags?: FeatureFlags;
  readonly landing?: PermissionLanding;
};

const DEFAULT_LANDING_RULE_PRIORITY = {
  EXECUTIVE_SUMMARY: 10,
  SPARXS_EDITOR: 20,
} as const;

export const PERMISSION_RULES: readonly PermissionRule[] = [
  {
    id: "customer-statistics-suite",
    when: (ctx) => ctx.groups.includes(COGNITO_GROUP_NAMES.CUSTOMER_STATISTICS),
    patch: {
      executivesummary: true,
      sparxscatalog: true,
      channeldetail: true,
    },
    landing: {
      priority: DEFAULT_LANDING_RULE_PRIORITY.EXECUTIVE_SUMMARY,
      toPath: ROUTE_PATHS.EXECUTIVE_SUMMARY,
    },
  },
  {
    id: "internal-sparxs-editor",
    when: (ctx) =>
      ctx.groups.includes(COGNITO_GROUP_NAMES.INTERNAL_SPARXS_EDITOR) &&
      ctx.isExagens,
    patch: { sparxseditor: true },
    featureFlags: {
      flags: ["sparxEditor"],
      requiresAll: true,
    },
    landing: {
      priority: DEFAULT_LANDING_RULE_PRIORITY.SPARXS_EDITOR,
      toPath: ROUTE_PATHS.SPARXS_EDITOR,
    },
  },
  {
    id: "internal-util-svg",
    when: (ctx) =>
      ctx.groups.includes(COGNITO_GROUP_NAMES.INTERNAL_UTIL) && ctx.isExagens,
    patch: { svgalteration: true },
    featureFlags: {
      flags: ["svgAlteration"],
      requiresAll: true,
    },
  },
];
